import { render, staticRenderFns } from "./ContributionSummaryComponent.vue?vue&type=template&id=bc412976&"
import script from "./ContributionSummaryComponent.vue?vue&type=script&lang=ts&"
export * from "./ContributionSummaryComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ContributionSummaryComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports